import styled from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';

export const ProlongationHandlerContainerWrapper = styled.div<{ colors: ColormapInterface }>`
  width: 100%;
  display: inline-flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
`;

export const ModalExtensionTitleStyle = {
  color: '#ffffff',
  fontSize: '18px',
  textAlign: 'center',
  userSelect: 'none',
};
